import React, { useEffect, useState } from 'react';
import FinanceDashboard from './FinanceDashboard'
import moment from 'moment';
import { RootState } from 'src/redux/store';
import { useSelector } from 'react-redux';
import { useGetAllFinanceSummaryQuery } from 'src/services/DashboardService';
import { CircularProgress } from '@mui/material';

const FinanceDashboardWrapper = () => {

    // QUARY Profit Loss
    const {
        dateFilter,
    } = useSelector((state: RootState) => state.financeDashboad);

    const [profitLossReportData, setProfitLossReportData] = useState<any>()

    // Get the first and last months of the current year
    const currentYear = moment().year();
    const firstMonth = moment(`${currentYear}-01-01`).format('YYYY-MM'); // January of the current year
    const lastMonth = moment(`${currentYear}-12-01`).format('YYYY-MM');  // December of the current year

    console.log('First Month of the Year:', firstMonth);
    console.log('Last Month of the Year:', lastMonth);
    const { data: financeSummaryData, isLoading: isFinanceIsLoading, isFetching: iseFinanceIsFetching } = useGetAllFinanceSummaryQuery({
        dateFilter: {
            startMonth: dateFilter.startDate
                ? moment(dateFilter?.startDate).format("YYYY-MM")
                : firstMonth,
            endMonth: dateFilter.endDate
                ? moment(dateFilter?.endDate).format("YYYY-MM")
                : dateFilter.startDate ? moment().format("YYYY-MM") : lastMonth,
        },
    });

    // USE EFFECT PROFIT LOSS QUERY
    useEffect(() => {
        if (!isFinanceIsLoading && !iseFinanceIsFetching) {
            setProfitLossReportData(financeSummaryData?.result);
        }
    }, [financeSummaryData, isFinanceIsLoading, iseFinanceIsFetching]);

    return (
        <div>
            {(isFinanceIsLoading || iseFinanceIsFetching) && (
                <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                    <CircularProgress />
                </div>
            )}
            <FinanceDashboard profitLossReportData={profitLossReportData} />
        </div>
    )
}

export default FinanceDashboardWrapper